var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideBar',{attrs:{"header":{name: 'KPI', logo: _vm.HeaderLogo, to:{ name: 'mainHomes' }},"items":_vm.filteredNavigations,"support":{title:_vm.$t('support'),icon:_vm.TelegramIcon,to:'https://t.me/DT_ECOSYSTEM_SUPPORT'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }